import type { I18n } from '@/typings/i18n'

const de: I18n = {
  global: {
    indexTitle: 'LOOK',
    tipsTitle: 'Tipp',
    confirmButtonText: 'Bestätigen',
    cancelButtonText: 'Abbrechen',
    day: 'Tag',
    people: 'Person',
    bindButtonText: 'Binden',
    help: 'Hilfe',
    manageSubscription: 'Abonnement verwalten',
    coupon: 'Meine Gutscheine',
    deleteMessage: 'Möchten Sie wirklich löschen?',
    deleteButtonText: 'Löschen',
    renameButtonText: 'Umbenennen',
    downloadButtonText: 'Herunterladen',
    install: 'installiert',
    phoneNumberLabel: 'Handynummer',
    verificationCodeLabel: 'Verifizierungscode',
    sendButtonText: 'Senden',
    saveButtonText: 'Speichern',
    download: 'Herunterladen',
    complete: 'Abschließen',
    adjustButtonText: 'Anpassen',
    eraser: 'Radiergummi',
    undo: 'Rückgängig machen',
    redo: 'Wiederholen',
    clear: 'Löschen',
    noDataMessage: 'Keine Daten',
    loading: 'Wird geladen',
    customize: 'Anpassen',
    referenceImage: 'Referenzbild',
    styleImage: 'Stilbild',
    high: 'Hoch',
    middle: 'Mittel',
    low: 'Niedrig',
    big: 'Groß',
    small: 'Klein',
    select: 'Auswählen',
    upload: 'Hochladen',
    colon: ':',
    uploadDesc: 'Klicken oder ziehen Sie Dateien in diesen Bereich, um sie hochzuladen',
    generate: 'Generieren',
    preview: 'Vorschau',
    magic: 'Intelligent',
    add: 'Hinzufügen',
    subtract: 'Reduzieren',
    brush: 'Pinsel',
    part: 'Teil',
    commonlyUsed: 'Häufig verwendet',
    recommend: 'Empfehlen',
    termsOfService: 'Nutzungsbedingungen',
    userAgreement: 'Benutzervereinbarung',
    privacyStatement: 'Datenschutzerklärung',
    wechat: 'WeChat',
    xiaohongshu: 'Xiaohongshu',
    downloadClient: 'client herunterladen',
    ok: 'Okay',
    and: ' und ',
    language: 'Sprache',
    copy: 'Kopieren',
    copyLink: 'Link kopieren',
    signupTitle: 'Anmelden',
    signupTitleSuffix: 'LOOK AI Echtzeit-Modedesign-Tool',
    recentsTitle: 'Kürzlich generiert - LOOK',
    projectNameTitle: '{projectName} - LOOK',
    nextStep: 'Nächster Schritt',
    accept: 'Akzeptieren',
    reject: 'Ablehnen',
    about: 'Über',
    close: 'Schließen',
    skip: 'Überspringen',
    iKnow: 'Ich weiß'
  },
  system: {
    updateTip: 'Die neue Version wurde heruntergeladen. Klicken Sie, um zu aktualisieren.',
    updateMessage: 'Möchten Sie die Anwendung wirklich schließen und das Update installieren?',
    drawingDownMessage: 'Funktion erfordert den Download des Clients.',
    bonjourInstallTitle: 'Bonjour nicht installiert',
    bonjourInstallMessage1: 'Der Bildschirmspiegelungsempfangsdienst wurde nicht erkannt,',
    bonjourInstallMessage2:
      ' die Funktion kann nicht normal ausgeführt werden. Bitte laden Sie Bonjour herunter und installieren Sie es, dann starten Sie LOOK neu.',
    bonjourInstallMessage3:
      'Wenn das Herunterladen immer noch nicht funktioniert, klicken Sie auf "Noch nicht verfügbar".',
    bonjourUnavailableTitle: 'Bonjour nicht installiert',
    bonjourUnavailableMessage1: 'Der Bildschirmspiegelungsempfangsdienst wurde nicht erkannt,',
    bonjourUnavailableMessage2:
      'Bitte folgen Sie dem Video-Leitfaden, um Bonjour zu deinstallieren',
    bonjourUnavailableMessage3:
      'Bitte installieren Sie Bonjour erneut, um den Bildschirmspiegelungsempfangsdienst zu starten',
    bonjourUnavailableMessage4:
      'Wenn es nach dem Herunterladen immer noch nicht funktioniert, besuchen Sie bitte unseren Discord:',
    bonjourStartTitle: 'Bonjour nicht korrekt gestartet',
    bonjourStartMessage1:
      'Der Bildschirmspiegelungsempfangsdienst wurde nicht korrekt gestartet, die Echtzeit-Design-Funktion kann nicht normal ausgeführt werden. Bitte folgen Sie den Anweisungen, um den Dienst zu starten',
    bonjourStartMessage2: 'dann',
    bonjourStartMessage3: 'LOOK neu starten',
    bonjourStartMessage4: '1、Öffnen Sie das Systemeinstellungen, suchen Sie nach "Dienste"',
    bonjourStartMessage5:
      '2、Klicken Sie mit der rechten Maustaste auf Bonjour in den Diensten und wählen Sie "Start"',
    bonjourStartMessage6: '3、LOOK neu starten',
    bonjourStartMessage7:
      'Wenn es nach dem Neustart immer noch nicht funktioniert, besuchen Sie bitte unseren Discord:',
    bonjourStartText: 'ordnungsgemäß gestartet',
    bonjourUnavailable: 'die Funktion kann nicht ordnungsgemäß ausgeführt werden',
    bonjourDownload: 'Bonjour herunterladen',
    revoUninstaller: 'Revo Uninstaller',
    forceUninstallMessage:
      'Achtung: Wenn Sie den Bildschirmspiegelungsempfangsdienst installiert haben, aber weiterhin wiederholt Aufforderungen erhalten, dass der Dienst nicht installiert ist, kann dies daran liegen, dass die Installation nicht vollständig erfolgreich war. Sie können versuchen, ein leistungsstarkes Deinstallationswerkzeug zu verwenden, um die Anwendungen Bonjour und Bonjour SDK zu deinstallieren, und dann versuchen, den Bildschirmspiegelungsempfangsdienst erneut zu installieren.',
    guideButtonText: 'Anleitung',
    noImageMessage: 'Kein Bild ausgewählt',
    aboutUsTitle: 'Über uns',
    weChatPublicAccountTitle: 'WeChat-Öffentlicher-Account',
    error400: 'Ungültige Anforderungsparameter',
    error403: 'Zugriff verweigert',
    error404: 'Anforderungsadresse nicht gefunden',
    error408: 'Zeitüberschreitung bei der Anforderung',
    error500: 'Interner Serverfehler',
    error501: 'Server nicht implementiert',
    error502: 'Gateway-Fehler',
    error503: 'Dienst nicht verfügbar',
    error504: 'Gateway-Zeitüberschreitung',
    copySuccess: 'Kopieren erfolgreich',
    copyError: 'Kopieren fehlgeschlagen：',
    browserTips:
      'Für eine bessere Benutzererfahrung verwenden Sie bitte den Chrome-Browser, um auf den Client zuzugreifen oder ',
    serviceStopMessage:
      'Ihre Pro-Abonnement wurde am {date} nicht automatisch erneuert. Wenn Sie die Frist nicht einhalten, wird der Dienst beendet.',
    renewalReminderMessage: 'Wenn Sie es weiterhin verwenden möchten, bitte',
    paymentLink: 'klicken Sie hier, um die Abonnementzahlung abzuschließen',
    updateTipsMessage:
      'LOOK hat eine neue Version erkannt und wird automatisch geschlossen, um das Update zu installieren.',
    osVersionNotSupportedMessageWindows:
      'Betriebssystemversionen unterhalb von Windows 10 64-Bit werden nicht unterstützt, was Ihre Benutzererfahrung beeinträchtigen kann. Es wird empfohlen, Ihr Betriebssystem zu aktualisieren oder über einen Browser zuzugreifen.',
    osVersionNotSupportedMessageMacOS:
      'Betriebssystemversionen unterhalb von Mac OS 13 werden nicht unterstützt, was Ihre Benutzererfahrung beeinträchtigen kann. Es wird empfohlen, Ihr Betriebssystem zu aktualisieren oder über einen Browser zuzugreifen.',
    updatedDownloadMessage:
      'LOOK hat eine neue Version erkannt und wird automatisch geschlossen, um das Update zu installieren.',
    receiverConnectErrorMessage:
      'Fehler bei der Verbindung des Bildschirmspiegelungsempfängers:{message}',
    receiverStartErrorMessage: 'Fehler beim Starten des Bildschirmspiegelungsempfängers:{message}',
    macOSVersionErrorMessage:
      'Fehler beim Starten des Bildschirmspiegelungsempfängers: Mac OS-Version ist zu niedrig, bitte aktualisieren Sie Ihr Betriebssystem.',
    airplayRTPErrorMessage:
      'Beim AirPlay-Streaming ist ein Netzwerkfehler aufgetreten. Bitte überprüfen Sie die Netzwerkverbindung und starten Sie LOOK neu.',
    networkDisconnectedMessage:
      'Netzwerkverbindung verloren, Bildschirmspiegelung gestoppt. Bitte überprüfen Sie Ihre Netzwerkverbindung.',
    networkReconnectedMessage:
      'Das Netzwerk wurde wiederhergestellt. Starten Sie LOOK neu und verbinden Sie Ihr Gerät erneut, um fortzufahren.',
    slogan1: 'KI-Echtzeit-Modedesign-Tool',
    slogan2: 'Präsentieren Sie Ihre Ideen in Echtzeit!',
    slogan3: 'Echtzeit-Design, echte Ergebnisse',
    slogan4: 'Skizzen sofort in Renderings umwandeln, mehrere Varianten generieren',
    slogan5: 'Stilfusion: Grenzen der Vorstellungskraft überschreiten',
    slogan6: 'Teilanpassungen: Präzise Kontrolle mit KI',
    networkErrorMessage:
      'Das Netzwerk ist derzeit nicht verbunden. Bitte überprüfen Sie die Netzwerkeinstellungen Ihres Geräts.',
    serverErrorMessage:
      'Die Verbindung zum Server ist fehlgeschlagen. Bitte versuchen Sie es später erneut.',
    languageChangeMessage:
      'Das Wechseln zu dieser Sprache erfordert eine erneute Anmeldung. Möchten Sie wirklich wechseln?',
    downloadAppMessage:
      'Erstmaliger Download und Anmeldung in der App für einen <br/><span style="font-weight: 700; font-size: 24px">ZUSÄTZLICHEN 1-TÄGIGEN kostenlosen Testzeitraum</span>',
    downloadButtonTextMac: 'Download für macOS',
    downloadButtonTextWindows: 'Download für Windows',
    consentTitle: 'Cookie-Hinweis',
    consentTips:
      'Um Ihnen einen besseren Service und ein personalisiertes Erlebnis zu bieten, verwenden wir Cookies und ähnliche Technologien, um die Website-Performance zu analysieren, personalisierte Werbung anzuzeigen und Social-Media-Funktionen bereitzustellen. Durch Klicken auf "Alle Cookies akzeptieren" oder durch die weitere Nutzung dieser Website stimmen Sie der Verwendung von Analyse- und Tracking-Cookies zu, die es uns ermöglichen, Ihnen ein persönlicheres Erlebnis zu bieten. In unserer <span style="font-weight: 700; text-decoration: underline; cursor: pointer">Cookie-Richtlinie</span> erfahren Sie mehr über die von uns verwendeten Cookies.',
    aboutTitle: 'LOOK Desktop-Anwendung',
    currentVersion: 'Version',
    newVersion: 'Neue Version',
    copyright: 'Copyright © 2024 LOOK AI LIMITED',
    checkUpdateButtonText: 'Nach Updates suchen',
    updateButtonText: 'Auf Version {version} aktualisieren',
    noUpdateMessage: 'Sie haben die neueste Version',
    updateFailMessage:
      'Update fehlgeschlagen, LOOK wird versuchen, das Update erneut nach einem Neustart zu installieren',
    appDownloadGuideTitle: 'LOOK Desktop-Client herunterladen',
    appDownloadGuideSubTitle:
      'Diese Funktion erfordert das Herunterladen des LOOK Desktop-Clients.',
    realtimeDesignGuideTitle: 'Real-Time Design Anleitung',
    realtimeDesignGuideSubTitle1:
      'Die Real-Time Design Funktion erfordert das Herunterladen des <img style="vertical-align: text-bottom" src="{image1}" width="16" height="16" /> LOOK Desktop-Clients und die Verwendung zusammen mit der <img style="vertical-align: text-bottom" src="{image2}" width="16" height="16" /> Procreate App.',
    realtimeDesignGuideSubTitle2:
      'Bitte öffnen Sie <img style="vertical-align: text-bottom" src="{image1}" width="16" height="16" /> Procreate und den <img style="vertical-align: text-bottom" src="{image2}" width="16" height="16" /> LOOK Desktop-Client und folgen Sie der Anleitung, um die Bildschirmspiegelung einzurichten.',
    freeCountLimitDialogTitle: 'Generierungslimit erreicht?',
    freeCountLimitDialogDesc:
      'Erstmaliger Download und Anmeldung in der App für einen <br/><span style="font-weight: 600; font-size: 24px">ZUSÄTZLICHEN 1-TÄGIGEN kostenlosen Testzeitraum</span>',
    freeCountLimitDialogDescMobile:
      'Erstmaliger Download und Anmeldung in der App auf<br/><span style="font-weight: 600">PC oder macOS</span> für einen <br/><span style="font-weight: 600;font-size: 24px">ZUSÄTZLICHEN 1-TÄGIGEN kostenlosen Testzeitraum</span>',
    imageSizeTooLarge: 'Die Größe des Bildes darf nicht größer als {size}MB sein'
  },
  error: {
    invitationCodeUsed: 'Der Einladungscode wurde bereits verwendet',
    invitationCodeInvalid: 'Der Einladungscode ist ungültig',
    networkErrorTitle: 'Netzwerkfehler',
    networkErrorMessage:
      'Verbindung zum Server nicht möglich. Bitte überprüfen Sie Ihre Netzwerkverbindung und versuchen Sie es erneut',
    retryButtonText: 'Wiederholen',
    upscaleScaleError:
      'Upscale ist nicht erlaubt. Bitte aktualisieren Sie Ihr Abonnement, um höhere Bildqualität freizuschalten.',
    campaignSystemError: 'Systemfehler, bitte versuchen Sie es später erneut',
    campaignUserAuthError: 'Fehler beim Abrufen der Benutzeridentität',
    campaignParamError: 'Parameterfehler',
    campaignQueryError: 'Abfragefehler',
    campaignNotCompleted: 'Aktivitätsaufgabe nicht abgeschlossen',
    campaignRewardAlreadyClaimed: 'Belohnung bereits beanspruft',
    campaignCouponNotAvailable: 'Gutschein nicht verfügbar',
    campaignUseCoupon: 'Fehler beim Verwenden des Gutscheins',
    campaignAssignCoupon: 'Fehler beim Zuweisen des Gutscheins',
    userGoogleAuthFail: 'Google-Anmeldung fehlgeschlagen',
    userNotSupportLoginType: 'Nicht unterstützter Anmeldetyp',
    userSystemError: 'Systemfehler',
    userLoginError: 'Anmeldung fehlgeschlagen'
  },
  account: {
    logoutMessage: 'Möchten Sie sich wirklich abmelden?',
    logoutButtonText: 'Abmelden',
    bindPhoneTitle: 'Handy binden',
    bindPhoneSuccessMessage: 'Handy erfolgreich verbunden',
    bindPhoneTips: 'Verbinden Sie Ihre Handynummer, um eine kostenlose Mitgliedschaft zu erhalten',
    bindPhoneEmptyNumberMessage: 'Bitte geben Sie Ihre Handynummer ein',
    bindPhoneErrorNumberMessage: 'Keine gültige Handynummer',
    bindPhoneVerificationCodeEmptyMessage: 'Bitte geben Sie den Bestätigungscode ein',
    getInvitationCodeErrorMessage: 'Abrufen der Einladungscode-Informationen fehlgeschlagen',
    trialDuration: 'Kostenlose Testphase: ',
    headerGiftText: 'Gutschein einlösen',
    headerOneDayGiftText: '{discount}% Rabatt auf Mitgliedschaft',
    headerSubscribeGiftText: 'Jetzt abonnieren',
    invitePopoverTitle: 'Freunde einladen',
    invitePopoverDescTips:
      'Neue Benutzer, die ihr Mobiltelefon verbinden, gelten als erfolgreiche Einladung eines neuen Benutzers',
    invitePopoverMark: 'Erhalten Sie&nbsp;<span>15 $US</span>&nbsp;Gutschein!',
    invitePopoverDesc:
      'Für jeden Freund, den Sie einladen, erhalten Sie einen Gutschein im Wert von 15 $US, der für Abonnement/Erneuerung verwendet werden kann! Ihr Freund erhält eine 15-tägige kostenlose Testversion!',
    invitePopoverCodeShareTitle: 'Zum Teilen scannen',
    invitePopoverCodeCopyTitle: 'Klicken, um den Einladungscode zu kopieren',
    invitePopoverShareCountText: 'Verbleibende Einladungen:',
    invitePopoverSubText:
      'Die Anzahl der Einladungscodes wird automatisch je nach Nutzung zugewiesen.',
    invitePopoverGiftDaysText: 'Gesammelte Gutscheine:',
    invitePopoverBindPhoneMaskText:
      'Verbinden Sie Ihr Mobiltelefon, um es zu aktivieren und Einladungsslots zu erhalten',
    phoneNumber: 'Handynummer:',
    noMemberText: 'Free',
    memberExpireAtFormat: 'DD/MM/YYYY',
    memberExpireAt: 'Ablaufdatum:',
    memberUpgradeMainText: 'Höhere Generationslimits für 4K-Bilder freischalten',
    memberUpgradeMainTextFirst: 'Erhalten Sie 50% Rabatt!',
    memberUpgradeSubText: 'Erreichen Sie Echtzeit-Designfreiheit!',
    memberUpgradeLinkTextActivate: 'AKTIVIEREN',
    memberUpgradeLinkTextUpgrade: 'UPGRADE',
    memberUpgradeLinkTextGet: 'ERHALTEN',
    memberUpgradeLinkTextManage: 'VERWALTEN',
    discordLoginTitle: 'Mit LOOK starten',
    discordLoginButtonText: 'Mit Discord fortfahren',
    discordLoginSubText1: 'Durch die Anmeldung erstellen Sie ein LOOK AI-Konto und stimmen den ',
    discordLoginSubText2: ' von LOOK AI zu.',
    googleLoginButtonText: 'Mit Google fortfahren',
    invitePageTitle: 'Hallo, Designer',
    invitePageNicknamePlaceholder: 'Spitzname',
    invitePageInvitationCodePlaceholder: 'Einladungscode',
    invitePageSubmitButtonText: 'Loslegen',
    invitePageTips: '<span style="font-weight: 700">8 TAGE GRATIS</span> mit Einladungscode',
    invitePageInvitationCodeInvalid: 'Einladungscode ungültig',
    hasInvitationCodeText: 'Ich habe einen Einladungscode',
    shareInvitationCodeText: `LOOK AI Echtzeit-Modedesign-Tool

💻 PC-Zugriff: https://app.lookfashion.ai
📱 Derzeit nicht für Mobilgeräte unterstützt

Einladungscode: {code}`,
    limitedTitle: 'Langsam runter…',
    limitedSubject:
      'Sie haben das Generierungslimit für <span style="font-weight: 600">{name}</span> erreicht,',
    limitedTime: 'Sie können den Dienst nach {time} weiter nutzen.',
    limitedRealtimeDesignTime: 'Bitte nutzen Sie den Dienst im nächsten Abonnementzyklus weiter.',
    upgradeTitle: 'Müde vom Warten?',
    upgradeSubject:
      'Mitgliedschaft upgraden, um <span style="font-weight: 600">sofort zu generieren</span>!',
    upgradeButtonText: 'Jetzt upgraden',
    mergeAccount: 'Ist das du?',
    mergeAccountDesc: 'Ja, Konto verbinden',
    mergeAccountCancel: 'Nein, zurück zur Anmeldung',
    recentLoginText: 'Letzter'
  },
  project: {
    recentListTitle: 'Kürzlich generiert',
    collectListTitle: 'Favoritenliste',
    projectListTitle: 'Projektliste',
    emptyMessage1: 'Noch keine Projekte erstellt',
    emptyMessage2: 'Klicken Sie unten, um ein Projekt zu erstellen',
    emptyMessage3: 'Generierung starten',
    emptyMessage4: 'Noch keine Bilder gespeichert, generieren und ',
    emptyMessage5: 'speichern, um Bilder hinzuzufügen',
    emptyMessage6:
      'Erstellen Sie zuerst ein neues Projekt und generieren Sie dann innerhalb des Projekts und ',
    emptyMessage7: 'LOOK speichern',
    createProjectButtonText: 'Neues Projekt',
    projectNamePlaceholder: 'Bitte geben Sie den Projektnamen ein',
    projectEnterText1: 'Projekt betreten',
    projectEnterText2: 'Arbeitsbereich betreten',
    createProjectTip: 'Bitte erstellen Sie zuerst ein Projekt'
  },
  image: {
    text2ImageTitle: 'Text-zu-Bild',
    originalityTitle: 'Skizze-zu-Bild',
    styleExtensionTitle: 'Stil-Erweiterung',
    styleFuseTitle: 'Stil-Verschmelzung',
    tuneTitle: 'Bereichsanpassung',
    recolorTitle: 'Intelligente Umfärbung',
    backgroundTitle: 'AI Szenenwechsel',
    eraserTitle: 'Magisches Radieren',
    cutoutTitle: 'Ein-Klick Freistellung',
    flowerPatternExpansionTitle: 'nahtloses Kachelmuster',
    aiExpansionTitle: 'AI-Erweiterung',
    hdTitle: 'Vergrößern',
    drawingTitle: 'Real-Time Design',
    patternTitle: 'Musterabbildung',
    imageCount: '',
    generateButtonText: 'LOOK generieren',
    generateButtonSubscribeBoxTitle1: '50% Rabatt für Erstabonnenten',
    generateButtonSubscribeBoxTitle2: 'Pro-Version freischalten',
    generateButtonSubscribeBoxDesc1:
      'Kostenlose Testversion abgelaufen? Schalten Sie jetzt weitere Generierungsprivilegien mit Rabatt frei!',
    generateButtonSubscribeBoxDesc2:
      'Auf Pro upgraden, um die Real-Time Design Freiheit zu erreichen!',
    generateButtonSubscribeBoxButtonText1: 'Kostenlos testen',
    generateButtonSubscribeBoxButtonText2: 'Auf Pro-Version upgraden',
    originalSizeText: 'Verhältnis',
    uploadImageButtonText: 'Bild hochladen',
    uploadPatternButtonText: 'Muster hochladen',
    editMaskButtonText: 'Maske bearbeiten',
    removeMaskButtonText: 'Maske löschen',
    imageUploaderDesc:
      '<span style="color: #4c4c4c; font-size: 14px">Zum Hochladen klicken oder ziehen</span><br/> <span style="color: #b0b2ae; font-size: 12px">(Bilder im Speicherbereich unten und rechts können direkt gezogen werden)</span>',
    generatePreviewText: 'Vorschau generieren({count}/{max})',
    previewListHelpMessage1:
      'Die generierten Bilder werden vorübergehend in dieser Liste gespeichert, bis zu {max} Bilder. Wenn es {max} Bilder überschreitet, wird das zuerst generierte Bild gelöscht.',
    previewListHelpMessage2:
      'Vorübergehende Bilder müssen im Album gespeichert werden, um dauerhaft erhalten zu bleiben und weitere Aktionen durchführen zu können.',
    clearPreviewButtonText: 'Alle Vorschauen löschen',
    segmentErrorMessage: 'Bildsemantikanalyse fehlgeschlagen, bitte versuchen Sie es erneut',
    generatingMessage: 'Bildgenerierung läuft',
    previewWaitingMessage: 'Bildverarbeitung, bitte warten',
    previewFailedMessage: 'Bildverarbeitung fehlgeschlagen, Anzeige nicht möglich',
    imageInQueueMessage: 'In der Warteschlange',
    imageNotVerifyMessage: 'Verstoß',
    saveImageButtonText: 'In Album speichern',
    deleteTmpImageButtonText: 'Temporäre Bilder löschen',
    previewImageInfoText: 'Bildinformationen',
    promptDefaultPlaceholder:
      'Geben Sie eine Beschreibung des Designs oder Stichwörter ein, um die Generierungsgenauigkeit zu verbessern',
    promptDefaultPlaceholder2: 'Geben Sie eine Beschreibung des Musters ein',
    promptDefaultPlaceholder3: 'Geben Sie eine Beschreibung des Bildes ein',
    promptDefaultPlaceholder4: 'Geben Sie eine Beschreibung des Modells ein',
    removeBgErrorMessage: 'Hintergrundentfernung fehlgeschlagen',
    removeBgButtonText: 'Hintergrund entfernen',
    removeBgLoadingMessage: 'Hintergrund wird entfernt, bitte warten',
    cropTip1:
      'Versuchen Sie, oben und unten im Bild genügend Platz zu lassen, um den Kopf und die Beine des Models zu generieren',
    cropTip2:
      'Wenn das hochgeladene Bild zu klein ist, schneiden Sie es bitte auf eine geeignete Größe zu',
    diyModelText: 'Benutzerdefiniertes Modell',
    commonModelText: 'Öffentliches Modell',
    exclusiveModelText: 'Exklusives Modell',
    promptTitle: 'Design-Merkmale',
    promptTitle2: 'Musterbeschreibung',
    promptTitle3: 'Bildbeschreibung',
    promptTitle4: 'Modellbeschreibung',
    promptInputTitle: 'Designmerkmale (Mehrfachauswahl)',
    selectModelTitle: 'Modellauswahl',
    referenceStrengthLabel: 'Referenzstärke',
    modelSettingTitle: 'Modelleinstellungen',
    advancedSettingsTitle: 'Erweiterte Einstellungen',
    negativePromptTitle: 'Negativer Hinweis',
    negativePromptPlaceholder:
      'Geben Sie Elemente ein oder wählen Sie sie aus, die nicht im Bild erscheinen sollen',
    generateCountTitle: 'Stapelgröße',
    cleanerTitle: 'Vordergrund entfernen',
    maskSwitchViewButtonText: 'Ansicht wechseln',
    regenerateButtonText: 'Erneut generieren',
    imageLoadingMessage: 'Bild wird geladen',
    maskGenerateFailedMessage: 'Fehler beim Erstellen der Maske',
    maskPreviewDialogConfirmButtonText1: 'Freistellung bestätigen',
    maskPreviewDialogConfirmButtonText2: 'Maske erstellen',
    maskPreviewDialogCancelButtonText: 'Weiter bearbeiten',
    objectRemovalDialogCancelButtonText: 'Weiter bearbeiten',
    objectRemovalFailedMessage: 'Entfernen des Vordergrunds fehlgeschlagen',
    magicMaskGenerateFailedMessage: 'Erstellen der intelligenten Maske fehlgeschlagen',
    partMaskDialogTitle: 'Bereich auswählen',
    imageAnalyzingMessage: 'Bildanalyse läuft',
    cutout: 'Freistellen',
    maskDialogConfirmButtonText1: 'Vorschau wird vorbereitet',
    maskDialogConfirmButtonText2: 'Vorschau generieren',
    maskDialogConfirmTip: 'Festgefahren? Versuchen Sie es noch einmal!',
    rangeOfChangeLabel: 'Anpassungsgrad',
    lesser: 'Kleine Variation',
    more: 'Große Variation',
    disableModelDesc:
      'Modell deaktivieren, bitte stellen Sie sicher, dass im Entwurf kein Modell enthalten ist',
    generateFailedMessage: 'Erstellen der Bildgenerierungsaufgabe fehlgeschlagen',
    taskNotEnoughTip:
      'Die maximale Anzahl gleichzeitiger Generierungsaufgaben wurde erreicht. Bitte versuchen Sie es später erneut.',
    saveTip1:
      'Das Speichern von {saveType} bedeutet, dass nach dem Speichern des Bildes die Schärfungsoperation automatisch durchgeführt wird.',
    saveTip2:
      'Wenn die Gesamtzahl der laufenden LOOK- und {saveType}-Aufgaben die maximale Anzahl gleichzeitiger Aufgaben erreicht hat, ist die {saveType}-Speicheroperation vorübergehend nicht verfügbar.',
    promptButtonText1: 'AI-Verfeinerung',
    promptButtonText2: 'Bildbeschreibung',
    promptButtonMessage: 'Bitte zuerst einen Prompt eingeben',
    promptButtonFailMessage: 'Generierung fehlgeschlagen, bitte erneut versuchen',
    colorMatchTitle: 'Farbübereinstimmung',
    colorMatchSubject: 'Modeillustration zu Foto',
    colorMatchDesc: 'Zeigt die ursprüngliche Farbe und Textur des Stoffes',
    patternExpansionSize: 'Erweiterungsgröße',
    patternExpansionSizeSmall: 'Klein',
    patternExpansionSizeMedium: 'Mittel',
    patternExpansionSizeLarge: 'Groß',
    flowerPatternExpansionStep1: '1.Ein nicht kontinuierliches Muster hochladen',
    flowerPatternExpansionStep2: '2.Wählen Sie den Bereich aus, den Sie erweitern möchten',
    flowerPatternExpansionStep3:
      '3.LOOK erweitert die Kanten des Musters, um das ursprüngliche Muster in ein kontinuierliches Muster zu verwandeln. Es kann gespeichert oder heruntergeladen werden, um für zukünftige Entwürfe zu verwenden.',
    maskCreateText: 'Maske erstellen'
  },
  cleaner: {
    maskDialogTitle: 'Wählen Sie den zu löschenden Bereich aus',
    maskDesc: 'Wählen Sie den zu löschenden Bereich'
  },
  drawing: {
    generatingMessage: 'Generierung läuft, bitte warten',
    startDrawingMessage: 'Bitte beginnen Sie zu zeichnen',
    waitingScreenMessage: 'Warten auf Bildschirmspiegelung...',
    canvasCropperGuideMessage:
      'Bitte schneiden Sie den Bildschirm auf die Leinwandgröße in LOOK zu',
    startDrawingButtonText: 'Design starten',
    stopDrawingButtonText: 'Klicken zum Stoppen',
    videoNotSupportMessage: 'Der aktuelle Browser unterstützt die Videowiedergabe nicht',
    canvasGuideMessage1:
      'Starten Sie <img src="{image}" width="26" height="26" /> Procreate und schalten Sie die <span style="font-weight: 700; text-decoration: underline">Canvas-Übertragung</span> aus und wieder ein',
    canvasGuideMessage2:
      'Hinweis: Die Canvas-Übertragung muss neu gestartet werden, auch wenn sie bereits aktiviert war',
    castScreenGuideMessage1: 'Die aktuelle Version unterstützt nur',
    castScreenGuideMessage2: ' Procreate Bildschirmspiegelung',
    castScreenGuideMessage2After: '',
    castScreenGuideMessage3:
      'Befolgen Sie die Anleitung, um die Bildschirmspiegelungsverbindung des iPads {placeholder} zu öffnen',
    castScreenGuideMessage4: '(Beide Geräte müssen im selben Netzwerk sein)',
    screenPreviewTitle: 'Casting-Vorschau',
    reCropButtonText: 'Erneut zuschneiden'
  },
  hd: {
    scaleTitle: 'Bildqualität verbessern',
    imageClaritySD: 'Speichern',
    imageClarityHD: 'In HD speichern',
    imageClarityUHD: 'In UHD speichern',
    imageClarityTextSD: 'SD',
    imageClarityTextHD: 'HD',
    imageClarityTextUHD: 'UHD',
    generatingMessage: ' Vergrößerung läuft'
  },
  matte: {
    maskDialogTitle: 'Bereich zum Behalten auswählen',
    maskDesc: 'Wählen Sie den Bereich zum Beibehalten',
    magicLabel: 'Intelligentes Freistellen'
  },
  originality: {
    lineDrawingTitle: 'Skizze',
    lineDrawingUploadTitle: 'Skizze hochladen',
    sampleClothesTitle: 'Musterkleidung'
  },
  recolor: {
    maskDialogTitle: 'Bereich zum Farbwechsel auswählen',
    maskDesc: 'Bitte wählen Sie den Bereich zum Farbwechsel aus',
    colorSelectTitle: 'Farbauswahl',
    getColorWarningMessage: 'Der aktuelle Browser unterstützt die Farbauswahlfunktion nicht'
  },
  styleFusion: {
    referenceImageDialogTitle1: 'Stilskizze'
  },
  background: {
    maskDialogTitle: 'Bereich zum Behalten auswählen',
    maskDesc: 'Wählen Sie den Bereich zum Beibehalten',
    backgroundDialogTitle: 'Hintergrund hinzufügen',
    backgroundDescTitle: 'Hintergrundbeschreibung',
    promptInputPlaceholder:
      'Geben Sie eine Beschreibung des Hintergrunds ein, um die Genauigkeit der Generierung zu verbessern',
    referenceBackgroundTitle: 'Referenzhintergrund',
    intelligentFillLightLabel: 'Intelligente Beleuchtung',
    backgroundGenerateTimeoutMessage:
      'Hintergrundgenerierung Zeitüberschreitung, bitte versuchen Sie es erneut',
    backgroundGenerateFailedMessage:
      'Hintergrundgenerierung fehlgeschlagen, bitte versuchen Sie es erneut',
    addBackgroundTitle: 'Hintergrund hinzufügen',
    backgroundSizeTitle: 'Hintergrundgröße',
    effectPreviewMessage: 'Effektvorschau',
    canvasEmptyMessage: 'Bitte fügen Sie zuerst einen Hintergrund hinzu'
  },
  text2Image: {
    textExampleMessage1:
      'Ein Lookbook-Foto eines italienischen Models, das übergroße Strickkleidung trägt, mit einer Nahaufnahme. Das Outfit ist ein kariertes Strickpullover, das aus Garnen in verschiedenen Farben besteht und die Outdoor- und Streetwear eines Modebrands repräsentiert. Fotografiert im Stil von Campbell Addy, es ist eine High-Fashion-Editorial-Aufnahme.',
    textExampleMessage2:
      'Ein modisches chinesisches Model trägt ein fließendes langes Kleid im modernen chinesischen Stil. Das Outfit zeichnet sich durch Farben mit geringer Sättigung und passende Drucke aus. Es handelt sich um einen Laufsteg-LOOK von der Shanghai Fashion Week, der ein modernes Modeempfinden zeigt.',
    textExampleMessage3:
      'Eine Nahaufnahme eines Modells, das ein Kleidungsstück mit strukturellen Teilungen trägt. Moderne Kleidung, einfach, sauber und fließend. Das Outfit ist eine Mischung aus Seide und Leinenstoffen, perfekt für ein Modemagazin-Cover.',
    textExampleMessage4:
      'Ein modisches Model trägt ein weißes Hemd mit exquisiter Stickerei. Das Hemd ist mit großen dunkelroten Blumenmustern und goldenen Stickdetails verziert, was ihm einen Hauch von Vintage-Eleganz verleiht. Das Model trägt ein Paar goldene runde Ohrringe, das Haar ist ordentlich zurückgekämmt und gibt ihr Gesicht frei. Der tiefgrüne Hintergrund hebt den Teint des Models und das Outfit hervor und verleiht dem Gesamtbild eine starke künstlerische Note. Das Foto hat eine weiche, niedrig gesättigte Tonalität, die eine ruhige und poetische Atmosphäre schafft.',
    textExampleMessage5:
      'Ein modisches Model solo, trägt einen leuchtend orangefarbenen, weiten Pullover aus dickem Strickmaterial mit hohem Kragen und leicht lockeren Ärmeln. Dazu trägt das Model einen dunkelblauen A-Linien-Lederrock mit glänzender Oberfläche und fester Textur. Die dicken Sohlen der High Heels verleihen dem LOOK ein schweres Gefühl. Komplettiert wird das Outfit durch eine orangefarbene Sonnenbrille mit blauen Gläsern, die dem gesamten Styling eine futuristische und dramatische Note verleiht. Die Kleidung verwendet hochsättige Farben mit starken Kontrasten, die einen auffälligen und mutigen visuellen Effekt erzeugen. Die Accessoires und das Make-up sind einzigartig und übertrieben und betonen die Personalisierung und die Kunst. Der Hintergrund ist schlicht.',
    textExampleMessage6:
      'Eine junge modische Frau trägt eine gelbe fluoreszierende Jacke, steht auf einer Straße in Japan, blauer Himmel, natürliches Licht, Oberkörperaufnahme',
    textExampleMessage7:
      'Ein elegantes weißes weibliches Model trägt einen dunkelgrauen minimalistischen V-Ausschnitt-Mantel und Martin-Stiefel, fotografiert im Stil von Theo Angelopoulos. Der Mantel besteht aus Kaschmirstoff der Marke Lemaire, mit Falten und einer überlappenden Knopfleiste, die eine ruhige und heilige Atmosphäre ausstrahlt. Die Szene spielt in einem nebligen Wald.',
    textExampleMessage8:
      'Eine modische Frau trägt einen mutigen grünen Strickpullover vor einem lila Hintergrund. Der Pullover hat ein einzigartiges Design mit weißen und blauen Elementen, die abstrakten Gesichtern ähneln. Der Stoff scheint ein dicker Strick zu sein, möglicherweise Wolle oder eine Wollmischung, die üblicherweise in dieser Art von Kleidung verwendet wird, um Wärme und Textur zu bieten. Der Schnitt ist locker, mit Ärmeln, die über die Handgelenke hinausreichen, lässig und übergroß. Das kräftige Grün dominiert den gesamten LOOK und bildet einen starken Kontrast zu schwarzen Hosen, was eine auffällige Farbkombination erzeugt. Der Gesamtstil ist avantgardistisch und fällt in den Bereich der zeitgenössischen Straßenmode.',
    textExampleMessage9:
      'Eine koreanische Mode-Influencerin trägt ein locker sitzendes hellblaues Jeanshemd mit weiten Ärmeln. Das Hemd scheint abgenutzt zu sein, mit mehreren Rissen und verblassten Stellen, was auf einen Vintage-Stil hinweist. Das Model trägt auch hellfarbene Shorts, möglicherweise aus Denim, passend zum Hemd. Sie hat glattes, schwarzes, langes Haar, einen neutralen Gesichtsausdruck und schaut geradeaus. Der Hintergrund ist hellgrau und hebt das Outfit hervor. Filmbeschaffenheit.',
    textExampleMessage10:
      'Ein koreanisches Model steht vor einem minimalistischen Hintergrund. Sie trägt eine übergroße, hellolivgrüne Strickjacke mit Kapuze, die sehr bequem und lässig aussieht. Die Strickjacke besteht aus dickem Strickstoff und verfügt über ein dreidimensionales geometrisches Muster. Der Schnitt ist locker, geeignet für Herbst- oder Winterkleidung. Das Model trägt außerdem eine dunkelbraune Baseballkappe, auf der das Logo deutlich sichtbar ist. Ihr Ausdruck ist neutral, und ihr Blick ist zur Seite gerichtet, was eine entspannte und lässige Atmosphäre vermittelt. Der gesamte Stil tendiert zu lässig und modisch, wobei Komfort und Modernität betont werden. Das Foto hat eine filmartige Textur.',
    textExampleMessage11:
      'Ein Model steht vor einem neutralen Hintergrund. Sie trägt ein einzigartiges cremeweißes Outfit mit weiten Ärmeln und asymmetrischem Saumdesign, das aus mehreren übereinander gestapelten Stoffschichten besteht und an traditionelle chinesische Kleidung erinnert. Der Stoff ist weich und fließend mit etwas Textur, wahrscheinlich aus leichtem Baumwoll- oder Seidengemisch. Der Schnitt ist locker und bietet einen modernen LOOK, der sowohl bequem als auch stilvoll ist. Das Outfit ist hauptsächlich cremeweiß, während die schwarze Hose einen Kontrast bietet. Der Gesamtstil tendiert zum Minimalismus mit einem Hauch von Eleganz. Das Model wirkt gepflegt, mit einer einfachen Frisur und einem ruhigen Ausdruck, was dem Gesamtlook eine Aura von Ruhe und Selbstvertrauen verleiht.',
    generationRatioTitle: 'Bildverhältnis',
    tryText: 'Probieren Sie es aus',
    freeProportionText: 'Frei'
  },
  tune: {
    maskDialogTitle: 'Bereich zum Bearbeiten auswählen',
    maskDesc: 'Wählen Sie den zu bearbeitenden Bereich aus',
    promptTitle: 'Aufforderung'
  },
  pattern: {
    maskDialogTitle: 'Bereich zum Einfügen auswählen',
    maskDesc: 'Wählen Sie den Bereich zum Einfügen aus',
    assistImagesTitle: 'Muster'
  },
  modelTryOn: {
    modelImageDialogTitle1: 'Modelldatei hochladen',
    modelImageDialogTitle2: 'Kleidung hochladen',
    maskDesc: 'Wählen Sie den Bereich zum Wechseln der Kleidung aus',
    maskDialogTitle: 'Bereich zum Wechseln der Kleidung auswählen',
    upperBodyTitle: 'Oberteil/Kleid',
    dressTitle: 'Unterteil',
    loadingText: 'Intelligente Auswahl läuft, bitte warten...',
    errorText: 'Intelligente Auswahl fehlgeschlagen, bitte erneut versuchen',
    upperBodyMaskDialogTitle: 'Bereich zum Wechseln der Oberteile/Kleidung auswählen',
    dressMaskDialogTitle: 'Bereich zum Wechseln der Unterteile/Kleidung auswählen',
    singleMaskDialogTitle: 'Bereich zum Wechseln der Modelldatei auswählen',
    single: 'Einzelnes',
    multi: 'Mehrere',
    singleTitle: 'Einzelnes Kleidungsstück'
  },
  modelFace: {
    uploadImageTitle: 'Originalbild hochladen',
    maskDialogTitle: 'Bereich des Gesichts des Menschen zeichnen',
    maskDesc: 'Bitte zeichnen Sie den Bereich des Gesichts des Menschen',
    selectModelTitle: 'Modelldatei hochladen',
    modelSelectorDesc: '<span style="color: #4c4c4c; font-size: 14px">Klicken Sie, um das Modell auszuwählen</span>',
    headSize: 'Kopfgröße'
  },
  diyModel: {
    sex: 'Geschlecht',
    male: 'Männlich',
    female: 'Weiblich',
    age: 'Alter',
    kid: '5',
    juvenile: '15',
    adult: '25',
    youth: '35',
    middleAged: '50',
    elderly: '60',
    color: 'Hautfarbe',
    bodyShape: 'Körperbau',
    hair: 'Haare',
    length: 'Länge',
    hairstyle: 'Frisur',
    slenderBody: 'Schlanker Körper',
    hourglassBody: 'Ausgewogener Körper',
    muscularBody: 'Muskulös',
    babyFatBody: 'Pummelig',
    shortAndFatBody: 'Klein und dick',
    curvaceousBody: 'Kurvige Figur',
    straight: 'Glattes Haar',
    wavy: 'Welliges Haar',
    curly: 'Lockiges Haar',
    braided: 'Geflochtenes Haar',
    naturallyCurly: 'Natürlich gelocktes Haar',
    updo: 'Hochgestecktes Haar',
    airBangs: 'Luftiger Pony',
    dreadlocks: 'Dreadlocks',
    ponytail: 'Pferdeschwanz',
    bald: 'Glatzkopf',
    centerPartedHair: 'Mittelscheitel',
    bangs: 'Gerader Pony',
    frontBangs: 'Stirnfransen',
    short: 'Kurze Haare',
    long: 'Lange Haare',
    shoulderLength: 'Mittellange Haare',
    extraLongHair: 'Sehr lange Haare',
    pixieCut: 'Ohrlange Haare',
    collarboneLengthHair: 'Schulterlange Haare',
    shoulderLengthHair: 'Über die Schulter lange Haare',
    waistLengthHair: 'Taillenlange Haare',
    fairSkinWhite: 'Helle Hautfarbe',
    darkSkin: 'Dunkle Hautfarbe',
    yellowSkin: 'Gelbe Hautfarbe',
    asian: 'Asiat',
    european: 'Europäer',
    african: 'Afrikaner',
    american: 'Amerikaner',
    middleEastern: 'Middle-eastern'
  },
  maskDialogHelpTip: {
    mask: 'Klicken Sie mit der Maus, um den Bereich zum Behalten auszuwählen',
    matte:
      'Laden Sie ein Bild hoch und klicken Sie mit der Maus auf den Bereich, den Sie behalten möchten. Wenn kein Ausschnitt erforderlich ist, klicken Sie bitte direkt auf die Bestätigungsschaltfläche.',
    cutout: 'Klicken Sie mit der Maus, um den Bereich zum Behalten auszuwählen',
    part: 'Klicken Sie mit der Maus, um den Bereich auszuwählen, der als Maske verwendet werden soll',
    objectRemoval:
      'Um einen Teil des Vordergrunds zu entfernen, klicken Sie auf "Vordergrund entfernen" und klicken Sie dann mit der Maus auf den Bereich, der entfernt werden soll. Wenn dies nicht erforderlich ist, klicken Sie direkt auf die Schaltfläche "Bestätigen".'
  },
  subscribe: {
    subscribeTitle:
      'Erstanmeldung Spezial&nbsp;<span style="font-size: 32px; font-weight: 500; line-height: 44.8px">{discount}% RABATT</span>&nbsp;Rabatt',
    subscribeTitleFree:
      'Erstes Abonnement gibt Ihnen&nbsp;<span style="font-size: 32px; font-weight: 500; line-height: 44.8px">7 Tage kostenlose Mitgliedschaft</span>',
    person: 'Mensch',
    month: 'Monat',
    year: 'Jahr',
    currency: '$US',
    mostPopularText: 'Beliebt',
    noMemberText: 'Kein Abonnement',
    subscribeSubText:
      'Automatische Verlängerung nach Ablauf der Mitgliedschaft, <span style="color: #0d0d0d">kehrt im nächsten Monat zum regulären Preis zurück</span>, kann jederzeit gekündigt werden',
    subscribeSubTextFree: 'Abonnements können jederzeit ohne zusätzliche Gebühren gekündigt werden',
    priceNegotiableText: 'Vertrieb kontakten',
    tryThisText: 'Meistgewählte',
    payButtonText1: 'Abonnieren',
    payButtonText1Free: '0.00$US Holen Sie sich 7 Tage kostenlose Testversion!',
    payButtonText2: 'Abonnieren',
    payButtonText3: 'Upgrade-Plan',
    payButtonText4: 'Aktuelles Abonnement',
    payButtonText5: 'Kundenservice',
    payButtonText6: 'Abo bearbeiten',
    payButtonText7: 'Abonnieren',
    payMessage1: ' ist der Plan nach Ablauf der kostenlosen Testphase',
    payMessage2: 'Wird aktiviert',
    payMessage3: 'Zahlung nach Ablauf der 15-tägigen Testphase',
    payMessage4: 'Bezahlen',
    payMessage5: 'Bitte scannen Sie den QR-Code, um die Zahlung abzuschließen',
    payMessage6:
      'Automatische Verlängerung zu {currency}{amount}/Monat nach Ablauf, kann jederzeit gekündigt werden',
    payMessage7:
      'Nach Ablauf der Testphase automatische Verlängerung zu {currency}{amount}/Monat, jederzeit kündbar',
    payMessage8: 'Bitte scannen Sie den QR-Code, um die Vertragsunterzeichnung abzuschließen',
    paySuccessText: 'Abonnement erfolgreich',
    paySubText: 'Aktivierung bedeutet Zustimmung',
    freeMemberSuccessDesc:
      'Die Gebühren werden nach Ablauf der 15-tägigen Mitgliedschafts-Testphase abgebucht. Das Abonnement kann jederzeit ohne zusätzliche Kosten gekündigt werden.',
    receiveAwardTitle: '🎉Willkommen bei LOOK',
    receiveAwardTitleTaskGuide: '🎉1-tägige kostenlose Testversion erhalten!',
    receiveAwardSubject:
      'Wir haben für Sie<br><span style="font-size: 24px; font-weight: 700">{number}-tägige&nbsp;kostenlose Testversion</span>&nbsp;vorbereitet',
    receiveAwardSubjectTaskGuide:
      'Erleben Sie die LOOK-Kernfunktionen ganz einfach',
    receiveAwardTip: 'Zu wenig?',
    receiveAwardButtonTextTaskGuide: 'Jetzt ausprobieren',
    receiveAwardButtonText: '{number}-tägige kostenlose Testversion für {currency}0,00',
    memberInvitedOnly: 'Nur auf Einladung',
    memberTipsStarter: 'Perfekt für einzelne Designer und KI-Neulinge.',
    memberTipsPlus: 'Für erfahrene Designer, die fortschrittliche KI-Tools benötigen.',
    memberTipsPro: 'Für Profis, die volle KI-Power und Premium-Funktionen suchen.',
    memberFreeDesc1Label: 'Generierte Bilder',
    memberFreeDesc1Value: '8 Bilder/Tag',
    memberFreeDesc2Label: 'Auflösung',
    memberFreeDesc2Value: 'Standard',
    memberFreeDesc3Label: 'Gleichzeitige Aufgaben',
    memberFreeDesc3Value: '2',
    memberFreeDesc4Label: 'Real-Time Design',
    memberFreeDesc4Value: 'Nein',
    memberDescStarter0Label: 'Generierungen',
    memberDescStarter0Value: 'Unbegrenzt',
    memberDescStarter1Label: 'Generierungsgeschwindigkeit',
    memberDescStarter1Value: 'Normal',
    memberDescStarter2Label: 'Gleichzeitige Generierungen',
    memberDescStarter2Value: '{count}',
    memberDescStarter3Label: 'Generierungsfrequenz',
    memberDescStarter3Value: '50 / 4 h',
    memberDescStarter4Label: 'Hochskalierungsfrequenz',
    memberDescStarter4Value: '8 / 4 h',
    memberDescStarter5Label: 'Bildqualität verbessern',
    memberDescStarter5Value: '2K',
    memberDescStarter6Label: 'Real-Time Design',
    memberDescStarter6Value: '1200 min / mo.',
    memberDescPlus0Label: 'Generierungen',
    memberDescPlus0Value: 'Unbegrenzt',
    memberDescPlus1Label: 'Generierungsgeschwindigkeit',
    memberDescPlus1Value: 'Schnell',
    memberDescPlus2Label: 'Gleichzeitige Generierungen',
    memberDescPlus2Value: '{count}',
    memberDescPlus3Label: 'Generierungsfrequenz',
    memberDescPlus3Value: '150 / 4 h',
    memberDescPlus4Label: 'Hochskalierungsfrequenz',
    memberDescPlus4Value: '16 / 4 h',
    memberDescPlus5Label: 'Bildqualität verbessern',
    memberDescPlus5Value: '3K',
    memberDescPlus6Label: 'Real-Time Design',
    memberDescPlus6Value: '3600 min / mo.',
    memberDescPro0Label: 'Generierungen',
    memberDescPro0Value: 'Unbegrenzt',
    memberDescPro1Label: 'Generierungsgeschwindigkeit',
    memberDescPro1Value: 'Turbo',
    memberDescPro2Label: 'Gleichzeitige Generierungen',
    memberDescPro2Value: '{count}',
    memberDescPro3Label: 'Generierungsfrequenz',
    memberDescPro3Value: 'Unbegrenzt',
    memberDescPro4Label: 'Hochskalierungsfrequenz',
    memberDescPro4Value: '48 / 4 h',
    memberDescPro5Label: 'Bildqualität verbessern',
    memberDescPro5Value: '4K',
    memberDescPro6Label: 'Real-Time Design',
    memberDescPro6Value: 'Unbegrenzt',
    stripeConfirmMessage1: 'Bestellung wird bearbeitet',
    stripeConfirmMessage2: 'Bitte bestätigen Sie, ob das Abonnement erfolgreich war?',
    stripeConfirmMessage3:
      'Um zu überprüfen, ob Ihre Karte gültig ist, werden wir eine Vorautorisierung von 1 {currency} vornehmen.',
    stripeConfirmMessage4:
      'Dies dient nur zur Verifizierung und <span style="font-weight: 600; color: #0d0d0d">führt zu keinen tatsächlichen Gebühren</span>, also seien Sie unbesorgt.',
    stripeSuccessMessage: 'Bestellung abgeschlossen!',
    stripeFailedMessage:
      'Verifizierung fehlgeschlagen, bitte versuchen Sie es erneut oder wählen Sie eine andere Zahlungsmethode.',
    stripeConfirmButtonText: 'Abonnement abgeschlossen',
    stripeCancelButtonText: 'Annuler',
    stripeEditBillingMessage: 'Abonnement für Rechnungsdaten wird bearbeitet...',
    stripeEditBillingConfirmButtonText: 'Vervollständigen',
    stripeUpgradeMessage: 'Möchten Sie das Abonnement wirklich upgraden?',
    stripeUpgradeSuccessMessage: 'Upgrade erfolgreich!',
    stripeSubscribeRenewButtonText: 'Abo fortsetzen',
    stripeSubscribeRenewConfirmMessage:
      'Möchten Sie die automatische Verlängerung wirklich wieder aufnehmen?',
    stripeSubscribeRenewSuccessMessage: 'Abonnement fortgesetzt',
    stripeSubscribeCancelButtonText: 'Kündigen',
    stripeSubscribeCancelConfirmMessage:
      'Möchten Sie die automatische Verlängerung wirklich kündigen?',
    stripeSubscribeCancelSuccessMessage: 'Abonnement gekündigt',
    cancelQuestionaireTitle: 'Bitte wählen Sie den Grund für die Abmeldung (Einzelauswahl)',
    cancelQuestionaireSubject:
      'Bitte wählen Sie eine der folgenden Optionen (Einzelauswahl), um uns zu helfen, den Grund für Ihre Kündigung zu verstehen.',
    cancelQuestionaireSelection1: 'Ich möchte das Abonnement einfach kündigen',
    cancelQuestionaireSelection2: 'Der Preis ist zu hoch',
    cancelQuestionaireSelection3: 'Der Serviceinhalt erfüllt meine Bedürfnisse nicht mehr',
    cancelQuestionaireSelection4: 'Schlechte Benutzererfahrung',
    cancelQuestionaireSelection5: 'Technische Probleme (z. B. häufige Fehler oder Unterbrechungen)',
    cancelQuestionaireSelection6: 'Ich habe eine bessere Alternative gefunden',
    cancelQuestionaireSelection7: 'Andere (bitte angeben)',
    cancelQuestionaireSelection8: 'Die Besseren',
    cancelQuestionaireSubmiteButtonText: 'Absenden',
    cancelQuestionaireCancelButtonText: 'Ich werde es noch mehr nutzen',
    cancelSuccessMainTitle: 'Ihr Abonnement wurde gekündigt',
    cancelSuccessSubject: 'Sie erhalten in Kürze eine Bestätigungs-E-Mail',
    reactivateTitle: 'Wollten Sie nicht kündigen?',
    reactivateSubject: 'Keine Sorge, wir reaktivieren Sie!',
    reactivateButtonText: 'Jetzt reaktivieren',
    upgradeTitle: 'Upgrade-Plan',
    upgradeSubject: 'Ihr Abonnement-Upgrade tritt sofort in Kraft.',
    upgradeDesc:
      'Die Kosten werden anteilig basierend auf den verbleibenden Tagen des aktuellen Monats berechnet und von der Gebühr des neuen Plans abgezogen.',
    qrcodeTimeout: 'QR-Code abgelaufen',
    clickToRefresh: 'Klicken Sie zum erneuten Versuch',
    cycleText: 'Monatlich abgerechnet',
    yearlyText: 'Jährlich abgerechnet',
    paymentTypeMonthlyText: 'Monatlich',
    paymentTypeYearlyText: 'Jährlich',
    freeUsageText: 'Reste der kostenlosen Generierung heute: {count}',
    currentSubscription: 'Aktuelles Abonnement',
    expiredText: 'Verlängerung: {date}'
  },
  similer: {
    similerTitle: 'Visuelle Suche',
    similerWaitingMessage: 'Komponente wird initialisiert, bitte warten',
    similerSearchFailedMessage: 'Suche fehlgeschlagen, bitte klicken Sie erneut',
    similerNoSimilarMessage: 'Keine ähnlichen Bilder gefunden',
    similerLoadingMoreDetailImageError:
      'Hochauflösendes Bild nicht geladen, bitte klicken Sie erneut'
  },
  taskType: {
    generate: 'Bildgenerierung',
    upscale: 'Hochskalierung',
    realtimeDesign: 'Echtzeit-Design'
  },
  rewardTask: {
    rewardTaskListTitle1: '8-Tage-Testversion erhalten',
    rewardTaskListTitle1Intl: 'Kernfunktionen testen',
    rewardTaskListDesc1: 'Telefon verbinden',
    rewardTaskListGuide1: 'Telefon verbinden',
    rewardTaskListDesc2: 'Projekt erstellen',
    rewardTaskListGuide2: 'Projekt erstellen',
    rewardTaskListDesc3: 'Skizze-zu-Bild',
    rewardTaskListGuide3:
      'Klicken oder ziehen Sie zum Hochladen von Bildern, um Skizzen, Stilzeichnungen, Modeillustrationen und echte Fotos in realistische Effekte umzuwandeln.',
    rewardTaskListDesc4: 'Skizze-zu-Bild (Farbübereinstimmung)',
    rewardTaskListGuide4:
      'In Skizze-zu-Bild wird durch Aktivierung der <span style="color: #4c4c4c; font-weight: 600; text-decoration-line: underline">Farbwiederherstellung</span> <img src="{img}" style="vertical-align: middle;" /> auf die Originalfarben Bezug genommen. Bei Deaktivierung werden die Farben zufällig generiert.',
    rewardTaskListDesc5: 'Stilerweiterung',
    rewardTaskListGuide5:
      'In der Stilerweiterung kann die KI schnell eine Reihe von Variationen basierend auf Ihren hochgeladenen Kleidungsbildern erstellen.',
    rewardTaskListDesc6: 'Stilmischung',
    rewardTaskListGuide6:
      'Für die Stilmischung müssen zwei Bilder hochgeladen werden, um Kleidung mit Inspirationsmaterialien zu verschmelzen und eine Fusion verschiedener Modestile zu erstellen.',
    rewardTaskListDesc7: 'Text-zu-Bild',
    rewardTaskListGuide7:
      'Geben Sie eine Beschreibung Ihres Designs ein, um einen LOOK zu generieren. Sie können <img src="{img}" style="vertical-align: middle; width: 13px; height: 13px;" /> KI-Verfeinerung und Bildbeschreibung verwenden, um beim Schreiben von Beschreibungen zu helfen.',
    getRewardButtonText1: 'Fertig',
    sketchToImageInitPrompt:
      'Ein schönes Model trägt ein asymmetrisches schulterfreies Kleid mit einem weiten Rock mit großen Falten und Wellen sowie glänzendem Stoff. Kombiniert mit dunklen spitzen High Heels strahlt dieses Kleid Eleganz und Modernität aus, mit einem leicht metallisch glänzenden Stoff.',
    sketchToImageColorInitPrompt:
      'Modefoto des Models in einem eleganten Outfit bestehend aus einem silbergrauen Leinen-Maxirock, einem schwarzen Rollkragenpullover und einer warmgelben karierten Weste. Das Outfit wird durch hohe Plateaustiefel und einen warmgelb-schwarz karierten Gürtel mit großer Schleife ergänzt. Die Weste und der Rock sind mit geometrischen Mustern verziert. Ihr Haar ist an der Stirn hochgesteckt und sie trägt eine Sonnenbrille. Ganzkörperaufnahme.',
    styleExtensionInitPrompt:
      'Ein hochmodernes Kleidungsstück mit einem strukturierten, kurzen Blazer mit scharfen Revers und asymmetrischen Taschendetails auf weißem Hintergrund. Der Blazer ist kombiniert mit einem drapierten, hochgeschnittenen Rock, der geschichtete Bahnen und fließende, asymmetrische Säume zeigt. Das Design betont eine avantgardistische Silhouette mit einer Mischung aus präziser Schneiderei und fließender Drapierung. Das Material scheint ein leichter, matter Stoff zu sein, wie Baumwolle oder eine Baumwollmischung, was ihm eine weiche und dennoch strukturierte Erscheinung verleiht. Die gedämpfte, erdige grüne Farbe unterstreicht die minimalistische und zeitgenössische Ästhetik. Das Gesamtdesign spiegelt eine Balance zwischen moderner Schneiderei und künstlerischer Fluidität wider, perfekt für Laufsteg- oder Editorial-Mode. Produktfotografie, detaillierte Texturen.',
    styleFusionInitPrompt:
      'Ein bunter grober Strickpullover mit einem dreidimensionalen gestrickten Schleifenmuster auf der Brust, auf weißem Hintergrund.',
    text2ImageInitPrompt:
      'Ein dunkelhäutiges Model trägt einen übergroßen Blazer und einen Lederrock, lange Beine in Stiefeln mit einer riesigen Schleife an der Ferse, posiert für eine Vogue-Modefotografie vor weißem Hintergrund. Das Bild ist hyperrealistisch.',
    limitTime: 'Limitiert  ',
    guideStartButtonText: 'Generieren',
    confirmCloseDialogTitle: 'Tutorial überspringen',
    confirmCloseDialogDesc:
      'Sind Sie sicher, dass Sie das Tutorial überspringen möchten? Sie werden es später nicht mehr ansehen können.',
    confirmCloseDialogCancelButtonText: 'Abbrechen',
    confirmCloseDialogConfirmButtonText: 'Ja, überspringen',
    rewardTitle: 'Ihr Design-Boost wartet auf Sie!',
    rewardDescription: 'Verwenden Sie Ihre Coupon und entdecken Sie neue, leistungsstarke Design-Funktionen jetzt.',
    couponType1: 'Rabatt',
    couponType2: 'Geld',
    expiredText: 'Gültig bis: ',
    useNow: 'Jetzt verwenden!'
  },
  contextMenu: {
    copy: 'Kopieren',
    paste: 'Einfügen',
    selectAll: 'Alles auswählen'
  },
  login: {
    success: 'Erfolgreich angemeldet',
    closeWindow: 'Sie haben sich erfolgreich angemeldet. Sie können dieses Fenster jetzt schließen.'
  },
  update: {
    updateDialogTitle: 'Update-Dialog',
    updateDialogMessage:
      'Es ist eine neue Version verfügbar. Möchten Sie die neue Version installieren?',
    updateDialogCurrentVersion: 'Aktuelle Version',
    updateDialogNewVersion: 'Neue Version',
    updateDialogCancelButtonText: 'Jetzt nicht',
    updateDialogUpdateButtonText: 'Installieren',
    updateDialogUpdateButtonLoadingText: 'Wird aktualisiert...'
  },
  updateError: {
    updateErrorDialogTitle: 'Update-Dialog',
    updateErrorDialogMessage:
      'Es ist eine neue Version verfügbar. Möchten Sie die neue Version installieren?',
    updateErrorDialogButtonText: 'Installieren'
  },
  updateProgress: {
    updateProgressDialogTitle: 'Wird aktualisiert...'
  },
  remainingBalance: {
    realTimeDesign: 'Real-Time Design',
    minute: 'Minute',
    hour: 'Stunde',
    frequency: 'Frequenz',
    upscale: 'Hochskalierung',
    last: 'Letzte',
    image: 'Bilder',
    unlimited: 'Unbegrenzt'
  },
  compositor: {
    opacity: 'Opazität',
    saturation: 'Sättigung',
    brightness: 'Helligkeit',
    contrast: 'Kontrast',
    hue: 'Farbton',
    depthMapFailed: 'Tiefenbild erstellt fehlgeschlagen, bitte versuchen Sie es erneut'
  },
  coupon: {
    couponListTitle: 'Meine Coupons',
    couponExpireCountdown: 'Verbleibende Zeit: ',
    couponExpire: 'Gültig bis: ',
    couponListEmpty: 'Keine Coupons verfügbar',
    couponListEmptyDescription1: 'Unseren offiziellen Discord-Kanal beitreten',
    couponListEmptyDescription2: 'Teilnehmen Sie an Aktivitäten und erhalten Sie großartige Geschenke!',
    couponListEmptyButton: 'Discord beitreten'
  },
  plugins: {
    pluginsTitle: 'Plugin-Store',
    addPluginButtonText: 'PIN',
    removePluginButtonText: 'UNPIN',
    addedPluginButtonText: 'PINNED',
    noImages: 'Keine Plugin-Bilder',
    noPluginComponentText:
      'Keine Plugin-Komponente gefunden, bitte überprüfen Sie, ob der Plugin korrekt konfiguriert ist',
    editPluginsButtonText: 'Plugin bearbeiten',
    editPluginsCompletedButtonText: 'Bearbeitung abgeschlossen',
    morePluginsButtonText: 'Mehr Plugins',
    removePluginTipsTitle: 'Plugin entfernen',
    removePluginTips1: 'Das Plugin kann erneut aus',
    removePluginTips2:
      '<span style="color: #0d0d0d; font-weight: 600;">Plugin-Store</span> hinzugefügt werden',
    pluginDisabled: 'Plugin nicht verfügbar',
    pluginsTips: {
      title: 'LOOK AI',
      subtitle: 'Plugin-Store verfügbar!',
      plugintipTitle1: 'All-in-One Tools:',
      plugintipDesc1:
        'Willkommen in unserem neuen Plugin-Markt! Wir haben alle Ihre Lieblingsfunktionen - Intelligente Neufärbung, KI-Szenenwechsel, Magisches Radieren, Ein-Klick-Freistellung und mehr - an einem praktischen Ort zusammengefasst. Einfach anheften, und schon sind sie wieder einsatzbereit!',
      plugintipTitle2: 'Arbeitsbereich anpassen:',
      plugintipDesc2:
        'Gehen Sie zu Plugin-Markt > Plugins hinzufügen > Klicken Sie in der linken Symbolleiste auf "Plugins bearbeiten", dann ziehen und ordnen Sie die Symbole nach Belieben! Ihr LOOK, Ihre Regeln!',
      plugintipTitle3: 'Weitere Plugins kommen bald!',
      plugintipDesc3:
        'Haben Sie Ideen? Teilen Sie uns mit, welche neuen Tools Sie sich wünschen, oder geben Sie uns Feedback. LOOK wurde für Sie entwickelt, und wir sind ganz Ohr!'
    },
    pluginsTipsFooter: {
      discord: 'Discord-Community beitreten',
      instagram: 'Mehr auf Instagram sehen',
      email: 'Email uns: {email}'
    }
  }
}

export default de as any
